import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const inputGroupAddonVariants = cva(
  cn(
    // Layout and typography
    'eye:flex eye:h-auto eye:cursor-text eye:items-center eye:justify-center eye:gap-8 eye:py-[6px] eye:text-14 eye:font-medium eye:text-grey-120 eye:select-none',
    // Disabled state
    'eye:group-data-[disabled=true]/input-group:opacity-50',
    // Icon sizing
    'eye:[&>svg:not([class*=size-])]:size-16',
  ),
  {
    variants: {
      align: {
        'inline-start': 'eye:order-first eye:pl-12',
        'inline-end': 'eye:order-last eye:ml-auto eye:pr-12',
        'block-start':
          'eye:order-first eye:w-full eye:justify-start eye:px-12 eye:pt-12 eye:group-has-[>input]/input-group:pt-8 eye:[.border-b]:pb-12',
        'block-end':
          'eye:order-last eye:w-full eye:justify-start eye:px-12 eye:pb-12 eye:group-has-[>input]/input-group:pb-8 eye:[.border-t]:pt-12',
      },
    },
    defaultVariants: {
      align: 'inline-start',
    },
  },
);

const inputGroupButtonVariants = cva(
  cn(
    // Layout
    'eye:flex eye:shrink-0 eye:items-center eye:justify-center eye:gap-8',
    // Typography and surface
    'eye:text-14 eye:shadow-none',
  ),
  {
    variants: {
      size: {
        xs: 'eye:h-24! eye:rounded-[3px]! eye:px-8! eye:text-14! eye:[&_svg:not([class*=size-])]:size-14',
        sm: 'eye:h-32! eye:rounded-md! eye:px-10! eye:text-14! eye:[&_svg:not([class*=size-])]:size-16',
        'icon-xs':
          'eye:size-24! eye:min-w-24 eye:rounded-[3px]! eye:p-0! eye:text-14! eye:[&_svg:not([class*=size-])]:size-16',
      },
    },
    defaultVariants: {
      size: 'xs',
    },
  },
);

export { inputGroupAddonVariants, inputGroupButtonVariants };
